import type { VerificationCodeProps } from './const';
import { VerificationCode as ArcoVerificationCode } from '@arco-design/web-react';
import { cn } from '@utils';
import { forwardRef } from 'react';
import './index.less';

function VerificationCode(props: VerificationCodeProps, ref: React.ForwardedRef<unknown>) {
  const { className, ...restProps } = props;

  return <ArcoVerificationCode ref={ref} className={cn('wg-verification-code', className)} {...restProps} />;
}

const VerificationCodeComponent = forwardRef<unknown, VerificationCodeProps>(VerificationCode);

VerificationCodeComponent.displayName = 'VerificationCode';

export default VerificationCodeComponent;
export type { VerificationCodeProps };
